import React, { useRef } from 'react';
import DateRangePicker, { DateRangePickerProps, Size } from '.';
import styled from 'styled-components';
import colors from '@/common/view/colors';

const Wrapper = styled.div<{ $error?: boolean }>`
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid ${({ $error }) => ($error ? colors.red50 : colors.gray30)};
  background: white;
  cursor: pointer;
`;

interface Props extends Omit<DateRangePickerProps, 'size'> {
  size?: Size | 'xsmall';
  error?: boolean;
}
const DateRangePickerButton: React.FC<Props> = ({ size, ...restProps }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  return (
    <Wrapper
      ref={wrapperRef}
      role="button"
      tabIndex={0}
      $error={restProps.error}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.target === wrapperRef.current) {
          wrapperRef.current?.querySelector('input')?.click();
        }
      }}
    >
      <DateRangePicker size={size === 'xsmall' ? 'small' : size} {...restProps} />
    </Wrapper>
  );
};

export default DateRangePickerButton;
